import React from "react"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"
import { useStaticQuery, graphql } from "gatsby"

const ClientReviews = ({ SlideToShow, SlideToScroll }) => {
  const clientReviewsData = useStaticQuery(graphql`
    query {
      allClientReviewsJson {
        edges {
          node {
            heading
            subheading
            reviews {
              rating
              usericon
              customerName
              businessName
              review
            }
          }
        }
      }
    }
  `)
  const reviewData = clientReviewsData.allClientReviewsJson.edges[0].node
  var settings = {
    dots: false,
    arrows: false,
    autoplaySpeed: 3000,
    slidesToShow: SlideToShow,
    slidesToScroll: SlideToScroll,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <Slider {...settings}>
      {reviewData.reviews.map((item, index) => (
        <div className="testimonial h-auto" key={index}>
          <div className="feedback h-100 ">
            <div className="feedback-stars lh-1 mb-4">
              <img
                src={item.rating}
                alt="five star rating"
                width="108"
                height="20"
              />
            </div>
            <div className="feedback-header d-flex align-items-center mb-35">
              <div className="flex-shrink-0">
                <img
                  src={item.usericon}
                  className="img-fluid client-logo"
                  alt="user icon"
                />
              </div>
              <div className="flex-grow-1 ms-20">
                <h6 className="feedback-author mb-5">{item.customerName}</h6>
                <p className="feedback-position font-size-14 m-0">
                  {item.businessName}
                </p>
              </div>
            </div>
            <p className="feedback-text fw-medium m-0">“{item.review}”</p>
          </div>
        </div>
      ))}
    </Slider>
  )
}

export default ClientReviews
